import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { formatPhoneNumber, unformatPhoneNumber } from 'dpl/shared/form/utils';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import Label from 'dpl/form/components/Label';

import Input from './Input';

export default function SimpleTelephoneInput({
  autoComplete,
  className,
  displayErrors,
  errors,
  fullWidth,
  id,
  inputClassName,
  label,
  name,
  onChange,
  required,
  value,
  testId,
  labelClassName,
  ...inputProps
}) {
  const inputValue = value || '';

  function handleChange(e) {
    const phoneNumber = unformatPhoneNumber(e.target.value);

    if (phoneNumber !== inputValue) {
      onChange(phoneNumber);
    }
  }

  return (
    <div
      className={classnames('TelephoneInput', className)}
      data-test-id={testId}
    >
      {label && (
        <Label
          className={labelClassName}
          htmlFor={id}
          required={required}
          text={label}
          newDesignSystemStyles
        />
      )}
      <ErrorWrapper
        isShown={displayErrors}
        errors={errors}
        newDesignSystemStyles
      >
        <Input
          {...inputProps}
          autoComplete={autoComplete}
          className={classnames(
            'TelephoneInput__input',
            {
              'w-auto': !fullWidth,
              'b--rubber': errors.length > 0 && inputValue.length > 0
            },
            inputClassName
          )}
          id={id}
          name={name}
          onChange={handleChange}
          type="tel"
          value={formatPhoneNumber(inputValue)}
        />
      </ErrorWrapper>
    </div>
  );
}

SimpleTelephoneInput.propTypes = {
  testId: PropTypes.string,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  displayErrors: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.node),
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  /** One of: "regular" or "large". */
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string
};

SimpleTelephoneInput.defaultProps = {
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#Values
  autoComplete: null,
  testId: 'form-simple-telephone-input',
  className: null,
  displayErrors: false,
  errors: [],
  fullWidth: false,
  id: null,
  label: null,
  required: false,
  value: null,
  inputClassName: null,
  labelClassName: null
};
